<template>
  <div
    class="member-activity"
    :class="{animate: animate}"
  >
    <perfect-scrollbar>
      <div class="member-current-status">
        <div class="name">
          <a
            href="javascript: void(0);"
            class="back-arrow"
            @click="goBack()"
          >
            <i class="atto atto-ldir-arrow-b" />
          </a>
          <h3>{{ member.name }}</h3>
        </div>
        <div class="section-title" v-if="header">
          <span>
            {{label.get('activity_current_status')}}
          </span>
        </div>
        <div
          v-if="header"
          class="activity-details"
          :class="getStatusClass(header.status)"
        >
          <div class="field-row status">
            <span class="clock-time first">{{ header.time }}</span>
            <div class="middle">
              <span class="inner-clockin"
                    :class="getStatusClass(header.status)"
              />
            </div>
            <span class="status-label last">{{ header.status_label }}</span>
            <a
              v-if="(header.status === 0 || header.status === 4) && member.id !== user.id"
              href="javascript:void(0);"
              class="atto-btn clockOut"
              @click="manualClockInOut(header)"
            >
              {{label.get('clock_out')}}
            </a>
            <a
              v-else-if="header.status === 1 && member.id !== user.id"
              href="javascript:void(0);"
              class="atto-btn clockIn"
              @click="manualClockInOut(header)"
            >
              {{label.get('clock_in')}}
            </a>
          </div>
          <div class="field-row location">
            <i
              v-if="header.latitude && header.enabled_location_tracking && header.enabled_location_permission"
              class="atto atto-location-marker-lt"
            />
            <i
              v-if="!header.latitude || !header.enabled_location_tracking || !header.enabled_location_permission"
              class="atto atto-no-location-pin"
            />
            <div class="location-details">
              <span
                v-if="header.latitude && header.enabled_location_tracking && locationTracking === 1"
                class="last-update"
              >
                {{label.get('map_last_location_update')}}  ·  {{ timeAgo(header.sync_time) }}
              </span>
              <span
                  v-if="header.latitude && header.enabled_location_tracking && locationTracking === 2"
                  class="last-update"
              >
                {{ getStatusLabel(header.status) }}
              </span>
              <span
                v-if="!header.enabled_location_tracking"
                class="last-update"
              >
                {{label.get('location_tracking_for_user_disabled')}}
              </span>
              <span
                v-else-if="!header.latitude && header.enabled_location_tracking"
                class="last-update"
              >
                {{label.get('location_not_available')}}
              </span>
              <p
                v-if="header.enabled_location_tracking && !header.enabled_location_permission"
                class="address b location-off"
              >
                {{label.get('location_permission')}}
                <i class="atto atto-alert-triangle" />
              </p>
              <p
                v-else
                class="address"
              >
                {{ header.address }}
              </p>

              <span
                v-if="header.accuracy"
                class="accuracy"
              >
                {{ header.accuracy }}
              </span>
            </div>
          </div>
          <div
            v-if="header.job"
            class="field-row"
          >
            <i class="atto atto-jobs-lt" />
            <span class="job-title">
              {{ header.job }}
            </span>
          </div>
        </div>
      </div>
      <div class="status detailed-status">
        <div class="section-title">
          <span>
            {{label.get('activity_earlier_today')}}
          </span>
        </div>

        <div v-for="(item, idx) in entries">
          <time-entry-component
              v-if="item.time_entry"
              :key="idx"
              :entry="item.time_entry"
              :member="member"
              :show-map="false"
          />
          <time-off-entry-component
              v-if="item.time_off_entry"
              :key="idx"
              :entry="item.time_off_entry"
              :member="member"
          />
        </div>
      </div>
    </perfect-scrollbar>
  </div>
</template>
<script>

    import ActivityService from "./shared/ActivityService";
    import TimeEntryComponent from '../timesheets/shared/components/TimeEntryComponent'
    import LocationService from "./shared/LocationService";
    import TimeOffEntryComponent from "../timesheets/shared/components/TimeOffEntryComponent";

    export default {
        name: "MemberActivityComponent",
        components: {
          TimeOffEntryComponent,
          TimeEntryComponent
        },
        props: {
            member: {
              type: Object,
              default: () => {
                return {};
              }
            }
        },
        data() {
          return {
              animate: false,
              showMap: false,
              header: null,
              entries: [],
              canManageEntry: true,
              disabledManualClockInOut: true,
              locationTracking: this.$store.state.companySettings.location_tracking
          }
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        created() {
            this.getMemberActivity();
        },
        mounted() {
            this.$root.$on('reloadData', this.getMemberActivity);
            this.$root.$on('reloadMemberActivity', this.getMemberActivity);
        },
        beforeDestroy() {
            this.$root.$off('reloadData');
            this.$root.$off('reloadMemberActivity');
        },
        methods: {
            getMemberActivity() {
                this.disabledManualClockInOut = true;
                ActivityService.getMemberActivity(this.member.uid).then((data) => {
                    this.header = data.header;
                    this.entries = data.entries;
                    if(this.header && this.header.latitude !== null && this.header.address === null) {
                      this.header.address = this.label.get('locating');
                      LocationService.getLocationAddress(this.header.latitude + ',' + this.header.longitude, this.member.id).then((result) => {
                          _this.header.address = result.address;
                      }).catch((error) => {
                          console.log(error);
                      });
                      this.$root.$emit('centerMap', this.header, false, false);
                    }

                    this.disabledManualClockInOut = false;
                    const _this = this;
                    setTimeout(function(){
                        _this.animate = true;
                        _this.$root.$emit('hideMemberOverlay');
                    }, 200);
                }).catch((error) => {
                    console.log(error);
                })
            },
            getStatusClass(status) {
                if (status === 0) {
                    return 'clockedIn';
                } else if (status === 1) {
                    return 'clockedOut';
                } else if (status === 4) {
                    return 'onBreak';
                }
            },
            getStatusLabel(status) {
              if (status === 0) {
                return this.label.get('clock_in_location');
              } else if (status === 1) {
                return this.label.get('clock_out_location');
              } else if (status === 4) {
                return this.label.get('break_start_location');
              }
            },
            timeAgo(syncTime) {
                let diff = this.$moment().diff(this.$moment(syncTime));
                if (diff * 0.001 < 60) {
                    return this.label.get('just_now');
                }
                return this.$moment(syncTime).startOf('minute').fromNow();
            },
            goBack() {
                const _this = this;
                _this.animate = false;
                setTimeout(function(){
                    _this.$root.$emit('closeMemberActivity');
                }, 200);
            },
            manualClockInOut(header) {
                if(this.disabledManualClockInOut) {
                    return;
                }

                if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
                    this.$root.$emit('noSubscription');
                    return;
                }
                const activity = {
                    id: header.user_id,
                    name: header.user_name,
                    timesheet: this.entries[0].time_entry
                };
                this.$root.$emit('showManualClockInOut', activity);
            }
        }
    }
</script>
<style lang="scss">

    .member-activity {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #efefef;
        transform: translateX(100%);
        -webkit-transition: ease all 0.2s;
        -moz-transition: ease all 0.2s;
        -ms-transition: ease all 0.2s;
        -o-transition: ease all 0.2s;
        transition: ease all 0.2s;
        .ps{
            max-height: calc(100vh - 73px);
        }
        &.animate {
            transform: translateX(0%);
        }
      .ps--active-x > .ps__rail-x{
        display: none;
      }
      .white-card{
        .session-wrap{
          .map-logs{
            display: none !important;
          }
        }
      }
    }

    .member-current-status {
      background: $atto-white;
        .name {
          display: flex;
          flex-direction: row;
          height: 60px;
          align-items: center;
          padding: 18px 30px;

            a.back-arrow {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 18px;

                i {
                    font-size: 16px;
                    color: $atto-font-color;
                    z-index: 1;
                }
                &:before{
                    content: '';
                    position: absolute;
                    z-index: 1;
                    width: 40px;
                    height: 40px;
                    top: 10px;
                    left: 21px;
                    border-radius: 100%;
                    background-color: #fff;
                    @include base-transition(ease all 0.1s);
                }

                &:hover {
                    cursor: pointer;
                    background-color: $atto-light-grey;
                    i {
                        color: $atto-font-color;
                        &:before {
                            color: $atto-font-color;
                        }
                    }
                    &:before{
                        background-color: $atto-light-grey;
                    }
                }
            }

            h3 {
                font: $roboto-regular 1.375rem/1.5rem $roboto-font;
                color: $atto-font-color;
            }
        }

        .activity-details {
            display: flex;
            flex-direction: column;
            padding: 40px 64px;

            .field-row {
                display: flex;
                flex-direction: row;
                align-items: center;

                > * {
                    display: inline-flex;
                }

                .first {
                    width: 80px;
                    min-width: 80px;
                    box-sizing: border-box;
                    padding-right: 118px;
                }

                .middle {
                  width: 24px;
                  padding-right: 55px;
                  justify-content: center;
                  min-width: 24px;
                  box-sizing: content-box;

                  .inner-clockin{
                    width: 24px;
                    height: 24px;
                    &.clockedOut{
                      background-image: url('~@assets/images/clock-out-pin.svg');
                    }
                    &.clockedIn{
                      background-image: url('~@assets/images/clock-in-pin.svg');
                    }
                    &.onBreak{
                      background-image: url('~@assets/images/on-break-pin.svg');
                    }
                  }
                }

                .last {
                    width: 255px;
                }

                &.status {
                    margin-bottom: 16px;

                    span.clock-time,
                    span.status-label {
                        font: $roboto-medium 1rem/1rem $roboto-font;
                    }

                    span.dot {
                        display: inline-flex;
                        height: 8px;
                        width: 8px;
                        border-radius: 8px;
                    }
                }

                &.location{
                    align-items: flex-start;
                    i{
                        width: 120px;
                        height: 24px;
                        font-size: 16px;
                        margin-top: 17px;
                        margin-left: 80px;
                        justify-content: center;
                        align-items: center;
                    }
                    .location-details{
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 16px;

                        .last-update{
                            font-family: $roboto-font;
                            font-weight: 400;
                            color: $atto-not-active;
                            font-size: 0.75rem;
                            line-height: 1rem;
                            margin-bottom: 4px;
                        }
                        .address{
                            font: $roboto-regular 0.875rem/1.25rem $roboto-font;
                            color: $atto-font-color;
                            margin-bottom: 4px;
                            max-width: 260px;

                            &.b.location-off {
                                font-weight: 500;
                                color: #E05656;

                                i {
                                    margin-left: 10px;
                                    padding: 0;
                                }
                            }
                        }
                        .accuracy{
                            font-family: $roboto-font;
                            font-weight: 400;
                            color: $atto-not-active;
                            font-size: 0.75rem;
                            line-height: 1rem;
                        }
                    }
                }

                &:last-child{
                    i{
                      width: 24px;
                      height: 24px;
                      padding-left: 50px;
                      padding-right: 70px;
                      justify-content: center;
                      align-items: center;
                      color: #c7c7c7;
                    }
                    .job-title{
                        font-family: $roboto-font;
                        font-weight: 500;
                        color: $atto-font-color;
                        font-size: 0.875rem;
                        line-height: 1rem;
                    }
                }

                .atto-btn {
                    margin-left: auto;
                    text-transform: uppercase;
                    min-width: 80px;
                }
            }

            &.clockedIn{
                .field-row{
                    .clock-time,
                    .status-label,
                    i.atto-location-marker-lt:before{
                        color: $atto-light-green;
                    }
                    .dot{
                        background-color: $atto-light-green;
                    }
                }
            }
            &.clockedOut{
                .field-row{
                    .clock-time,
                    .status-label,
                    i.atto-location-marker-lt:before{
                        color: $atto-red;
                    }
                    .dot{
                        background-color: $atto-red;
                    }
                }
            }
            &.onBreak{
                .field-row{
                    .clock-time,
                    .status-label,
                    i.atto-location-marker-lt:before{
                        color: $atto-orange;
                    }
                    .dot{
                        background-color: $atto-orange;
                    }
                }
            }
            &.pto{
                .field-row{
                    .clock-time,
                    .status-label,
                    i.atto-location-marker-lt:before{
                        color: $atto-not-active;
                    }
                    .dot{
                        background-color: $atto-not-active;
                    }
                }
            }
        }
    }

    div.section-title {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      height: 35px;
      background-color: #F7F7F7;
      border-top: 1px solid $atto-light-grey;
      border-bottom: 1px solid $atto-light-grey;

        span {
          padding: 12px 64px;
          font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
          letter-spacing: 0.5px;
          color: #666666;
          text-transform: uppercase;
        }
    }

    .detailed-status {

        width: 100% !important;

        .session{
            padding-top: 20px;
            padding-left: 0;
            padding-right: 0;
            .session-details{
                .session-name{
                    margin-left: 52px;
                }
            }
            .session-wrap{
                padding-left: 50px;
            }
          &.white-card{
            padding: 10px 44px;

            .white-card-header{
              border-bottom: none;
              .title-wrap{
                .session-name{
                  font: $roboto-regular 1.125rem/1.5rem $roboto-font;
                }
                .info-icon{
                  display: none;
                }
                &:after{
                  content: '';
                  display: flex;
                  background-color: #efefef;
                  width: 40px;
                  height: 2px;
                  position: relative;
                  top: 20px;
                }
              }
              .session-control-buttons-holder {
                .session-control-buttons{
                  button{
                    width: 24px;
                    height: 24px;
                    overflow: hidden;
                    justify-content: flex-start;
                    flex-flow: wrap-reverse;

                    i.atto{
                      margin: 0;
                      font-size: 18px;
                      &:before{
                        color: #C7C7C7;
                      }
                    }
                    &.delete-session{
                      margin-left: 16px;
                    }
                  }
                }
              }
            }
            .session-wrap{
              padding: 40px 20px 48px;
            }
          }
        }

        .hour-logs {
            padding: 53px 50px 40px;
            ul {
                display: flex;
                flex-direction: column;
                margin-bottom: 0 !important;

                li {
                    display: inline-flex;
                    flex-direction: row;
                    align-items: flex-start;
                    padding-bottom: 40px;

                    .hour {
                        font-family: $roboto-font;
                        font-weight: 500;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        color: $atto-not-active;


                      width: 80px;
                      min-width: 80px;
                      box-sizing: border-box;
                      padding-right: 118px;
                      margin: 0 !important;

                    }

                    .path {
                        display: flex;
                        min-height: 24px;
                        position: relative;
                        flex-direction: column;
                        justify-content: center;


                      width: 24px;
                      padding-right: 55px;
                      justify-content: center;
                      min-width: 24px;
                      box-sizing: content-box;
                      margin: 0 !important;

                        i.dot-connect {
                            display: inline-flex;
                            align-self: center;
                            width: 8px;
                            height: 8px;
                            background-color: $atto-dark-grey;
                            border-radius: 8px;
                            position: relative;
                            z-index: 2;
                        }

                        .connect-line {
                            position: absolute;
                            width: 2px;
                            top: 16px;
                            left: 15% !important;
                            margin-left: -1px;
                            height: 57px;
                            background-color: $atto-light-grey;
                            z-index: 1;
                        }
                    }

                    .log-description {
                       /* min-width: 320px;*/
                        min-width: 260px;
                        width: 44.44%;

                        h4 {
                            color: $atto-font-color;
                            font-family: $roboto-font;
                            font-size: 0.9375rem;
                            line-height: 1.5rem;
                            font-weight: 400;
                        }

                        span {
                            font-family: $roboto-font;
                            font-size: 0.875rem;
                            line-height: 1.25rem;
                            font-weight: 500;
                            color: $atto-not-active;
                        }
                    }

                    &.clockedIn,
                    &.clockedOut {
                        .path {
                            .connect-line {
                                height: 81px;
                            }
                        }

                        .hour {
                            font-size: 1rem;
                            color: $atto-font-color;
                        }

                        .log-description {
                            h4 {
                                font-size: 1rem;
                                font-family: $roboto-font;
                                font-weight: 500;
                            }
                        }
                    }

                    &.clockedIn {
                        .path {
                            .dot-connect {
                                background-color: $atto-green;
                            }
                        }
                    }

                    &.clockedOut {
                        .path {
                            .dot-connect {
                                background-color: $atto-red;
                            }
                        }
                    }

                    &.breakIn {
                        .path {
                            i.dot-connect {
                                background-color: $atto-orange;
                            }

                            span.connect-line {
                                background-color: $atto-orange;
                            }
                        }
                    }

                    &.breakOut {
                        .path {
                            i.dot-connect {
                                background-color: $atto-orange;
                            }
                        }
                    }
                    &:last-child{
                      padding-bottom: 0 !important;
                    }
                }
            }

            &:after {
                display: none !important;
            }
        }

        .notes-wrapper {
            display: flex;
            flex-direction: row;
            padding: 0px 50px 0px 171px;

            > i {
                display: inline-block;
                font-size: 18px;
                margin-right: 61px;
                margin-top: 3px;
            }

            .notes {
                h4 {
                    font-size: 1rem;
                    line-height: 1.5rem;
                    color: $atto-font-color;
                    font-family: $roboto-font;
                    font-weight: 500;
                    margin-bottom: 4px;
                }

                p {
                    font-size: 0.875rem;
                    line-height: 1.25;
                    font-family: $roboto-font;
                    font-weight: 400;
                    color: $atto-not-active;
                    margin-bottom: 20px;
                }

                &:after {
                    content: '';
                    display: inline-block;
                    width: 66px;
                    height: 5px;
                    margin-top: 19px;
                    background-color: $atto-not-active;
                }
            }
        }
    }
</style>